import React from 'react';
import './Style/WeightageChemistry2026.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const WeightageChemistry2026 = () => {
  // Structured Chemistry Data with Header Category Row Types
  const chemistryData = [
    // Inorganic Chemistry-I
    { isCategoryHeader: true, title: 'Inorganic Chemistry-I', totalWeightage: '22%' },
    { chapter: 'Chemical Bonding', questions: 4, weightage: '8%' },
    { chapter: 'p-block', questions: 3, weightage: '6%' },
    { chapter: 'Periodic Table & Periodicity in Properties', questions: 2, weightage: '4%' },
    { chapter: 'Hydrogen', questions: 1, weightage: '2%' },
    { chapter: 's-block', questions: 1, weightage: '2%' },

    // Inorganic Chemistry-II
    { isCategoryHeader: true, title: 'Inorganic Chemistry-II', totalWeightage: '12%' },
    { chapter: 'Coordination Compounds', questions: 2, weightage: '5%' },
    { chapter: 'd-block & f-block Elements', questions: 2, weightage: '3%' },
    { chapter: 'Metallurgy', questions: 1, weightage: '2%' },
    { chapter: 'Qualitative Analysis', questions: 1, weightage: '2%' },

    // Organic Chemistry-I
    { isCategoryHeader: true, title: 'Organic Chemistry-I', totalWeightage: '7%' },
    { chapter: 'General Organic Chemistry, Practical Organic Chemistry', questions: 2, weightage: '4%' },
    { chapter: 'Hydrocarbons', questions: 2, weightage: '3%' },

    // Organic Chemistry-II
    { isCategoryHeader: true, title: 'Organic Chemistry-II', totalWeightage: '27%' },
    { chapter: 'Aromatic Compounds', questions: 3, weightage: '6%' },
    { chapter: 'Haloalkane, Alkyl Halide, Alcohol & Ether', questions: 2, weightage: '3%' },
    { chapter: 'Biomolecules, Polymer', questions: 2, weightage: '3%' },
    { chapter: 'Carbonyl Compounds', questions: 2, weightage: '3%' },
    { chapter: 'IUPAC & Isomerism', questions: 2, weightage: '3%' },
    { chapter: 'Aldehydes, Ketones and Carboxylic Acids', questions: 2, weightage: '3%' },
    { chapter: 'Organic Compounds containing nitrogen', questions: 2, weightage: '3%' },
    { chapter: 'Chemistry in Everyday Life, Environmental chemistry', questions: 2, weightage: '3%' },

    // Physical Chemistry-I
    { isCategoryHeader: true, title: 'Physical Chemistry-I', totalWeightage: '17%' },
    { chapter: 'Mole Concept', questions: 2, weightage: '5%' },
    { chapter: 'Ionic Equilibrium', questions: 2, weightage: '4%' },
    { chapter: 'Atomic Structure & Nuclear Chemistry', questions: 1, weightage: '2%' },
    { chapter: 'Chemical Equilibrium, Gaseous State', questions: 1, weightage: '2%' },
    { chapter: 'Thermodynamics and Thermochemistry', questions: 1, weightage: '2%' },
    { chapter: 'Redox Reactions', questions: 1, weightage: '2%' },

    // Physical Chemistry-II
    { isCategoryHeader: true, title: 'Physical Chemistry-II', totalWeightage: '15%' },
    { chapter: 'Chemical Kinetics', questions: 2, weightage: '4%' },
    { chapter: 'Solution & Colligative Properties', questions: 2, weightage: '4%' },
    { chapter: 'Electrochemistry', questions: 1, weightage: '3%' },
    { chapter: 'Solid State', questions: 1, weightage: '2%' },
    { chapter: 'Surface Chemistry', questions: 1, weightage: '2%' },
  ];

  return (
    <div className="neetchem-container">
     
       <TopNavbar name="Chemistry Weightage 2026" ></TopNavbar>
       <TopHeader name="Chemistry Weightage 2026" ></TopHeader>


      {/* Main Content Area */}
      <main className="neetchem-content">
        <h2 className="neetchem-main-title">CHEMISTRY Chapter-Wise Weightage</h2>

        <p className="neetchem-paragraph">
          The Chemistry section contains several most important chapters for NEET that carry significant weightage. The NEET chapter weightage 2026 for Chemistry is outlined in the table given below:
        </p>

        {/* Chemistry Weightage Table */}
        <div className="neetchem-table-wrapper">
          <table className="neetchem-table">
            <thead>
              <tr>
                <th>Chemistry Chapters and Topics</th>
                <th className="neetchem-th-center">Average Number of Questions</th>
                <th className="neetchem-th-center">Average Weightage (%)</th>
              </tr>
            </thead>
            <tbody>
              {chemistryData.map((row, index) => {
                if (row.isCategoryHeader) {
                  return (
                    <tr key={index} className="neetchem-category-row">
                      <td className="neetchem-category-title">{row.title}</td>
                      <td className="neetchem-td-center neetchem-empty-cell">&mdash;</td>
                      <td className="neetchem-td-center neetchem-category-badge">
                        <span>{row.totalWeightage}</span>
                      </td>
                    </tr>
                  );
                }

                return (
                  <tr key={index} className="neetchem-item-row">
                    <td className="neetchem-td-chapter">{row.chapter}</td>
                    <td className="neetchem-td-center">{row.questions}</td>
                    <td className="neetchem-td-center neetchem-td-badge">
                      <span>{row.weightage}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </main>

    
    </div>
  );
};

export default WeightageChemistry2026;